import { render, staticRenderFns } from "./CoursewareBiographyAchievementsBlock.vue?vue&type=template&id=7a7566e4&scoped=true&"
import script from "./CoursewareBiographyAchievementsBlock.vue?vue&type=script&lang=js&"
export * from "./CoursewareBiographyAchievementsBlock.vue?vue&type=script&lang=js&"
import style0 from "./CoursewareBiographyAchievementsBlock.vue?vue&type=style&index=0&id=7a7566e4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7566e4",
  null
  
)

export default component.exports